export const bnpAiAdminQueryKeys = {
  all: ['BnpAiAdmin'] as const,
  aiToggleState: (entityUuid: string) => [...bnpAiAdminQueryKeys.all, 'aiToggleState', entityUuid] as const
};
